/** Platform brand name (set VITE_BRAND_NAME at build time). Marketing pages use the CMS value. */
export const BRAND = (import.meta.env.VITE_BRAND_NAME as string | undefined) ?? 'YJ Creator Studio';
